// KB search result card with confidence badge
import { Badge } from '@/components/ui/badge'
import { Database } from 'lucide-react'

interface KBResultCardProps {
  title: string
  description?: string
  similarity: number
  confidence: string
  d365Version?: string
  modules?: string[]
  sourceType?: string
}

const CONFIDENCE_COLORS: Record<string, string> = {
  high: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  medium: 'bg-blue-50 text-blue-700 border-blue-200',
  low: 'bg-amber-50 text-amber-700 border-amber-200',
}

export function KBResultCard({
  title, description, similarity, confidence, d365Version, modules, sourceType,
}: KBResultCardProps): JSX.Element {
  return (
    <div className="mt-2 rounded-lg border bg-white p-3">
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-center gap-2">
          <Database className="h-4 w-4 flex-shrink-0 text-kaycoo-teal-dark" />
          <p className="text-sm font-medium text-kaycoo-charcoal">{title}</p>
        </div>
        <div className="flex items-center gap-1.5">
          <Badge variant="outline" className={`text-xs ${CONFIDENCE_COLORS[confidence] ?? ''}`}>
            {confidence} ({(similarity * 100).toFixed(0)}%)
          </Badge>
          {sourceType === 'document' && (
            <Badge variant="outline" className="text-xs bg-purple-50 text-purple-700">doc</Badge>
          )}
        </div>
      </div>
      {description && (
        <p className="mt-1 line-clamp-2 text-xs text-gray-600">{description}</p>
      )}
      <div className="mt-2 flex flex-wrap gap-1">
        {d365Version && <span className="rounded bg-gray-100 px-1.5 py-0.5 text-xs">v{d365Version}</span>}
        {modules?.map((m) => <span key={m} className="rounded bg-gray-100 px-1.5 py-0.5 text-xs">{m}</span>)}
      </div>
    </div>
  )
}
